import classnames from 'classnames';
import { FC } from 'react';

export const BlotterSpinner: FC<{ className?: string; hide?: boolean }> = ({ hide, className }) => {
  if (hide === true) {
    return <div className={classnames('w-16px', className)} />;
  }
  return (
    <>
      <div className={classnames('spinner spinner-sm', className)} role="status" />
      <span className="visually-hidden">Blotter Loading...</span>
    </>
  );
};

BlotterSpinner.displayName = 'BlotterSpinner';
